let fragmentIdMap,
  initComponents,
  ref,
  ref1,
  ref2,
  ref3,
  translations,
  windowLoaded;

// eslint-disable-next-line prefer-const
({ windowLoaded } = require('@grpn/document-states'));

// KEEP THIS AT THE TOP OF THE FILE FOREVER
// eslint-disable-next-line consistent-return
windowLoaded.then(() => {
  if (
    typeof Groupon !== 'undefined' && Groupon !== null
      ? (ref = Groupon.Performance) != null
        ? ref.pageReady
        : void 0
      : void 0
  ) {
    return Groupon.Performance.pageReady();
  }
});

// eslint-disable-next-line prefer-const
initComponents =
  require('grpn-wh-components/lib/grpn-wh-components-light.js').initComponents;

// eslint-disable-next-line prefer-const
fragmentIdMap =
  typeof Groupon !== 'undefined' && Groupon !== null
    ? (ref = Groupon.Utils) != null
      ? (ref1 = ref.getConfigFromDom()) != null
        ? ref1.fragmentIdMap
        : void 0
      : void 0
    : void 0;

// eslint-disable-next-line prefer-const
translations =
  typeof Groupon !== 'undefined' && Groupon !== null
    ? (ref2 = Groupon.Utils) != null
      ? (ref3 = ref2.getConfigFromDom()) != null
        ? ref3.translations
        : void 0
      : void 0
    : void 0;

if (fragmentIdMap) {
  initComponents(fragmentIdMap, translations);
}
